<template>
  <!-- 国内航空首页 -->
  <div class="airIndex" @click="noneShow">
    <!-- 顶部搜索部分 -->
    <div class="condition-box df">
      <!-- <h2>实时航班查询</h2> -->
      <!-- 选择类型 -->
      <div class="air-type">
        <!-- <p>航程类型</p> -->
        <el-radio-group v-model="airType">
          <el-radio :label="1">单程</el-radio>
          <el-radio :label="2">往返</el-radio>
          <!-- <el-radio :label='3'>多程</el-radio> -->
        </el-radio-group>
      </div>
      <!-- 选择城市日期 -->
      <div style="width:calc(100% - 120px);">
        <div class="df">
          <div class="select-box df">
            <div class="city">
              <div class="starCity df">
                <p>出发城市</p>
                <el-autocomplete
                  id="starCity"
                  v-model="starCity1"
                  clearable
                  :fetch-suggestions="(val,cd)=>querySearch(val,cd,'starCity1')"
                  placeholder="中文/拼音/三字码"
                  :trigger-on-focus="false"
                  @select="getstarCity"
                  @focus.stop="CityFocus('starCity')"
                >
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }} ({{item.code}})</div>
                  </template>
                </el-autocomplete>
                <div class="cityList" v-if="starList" @click.stop="stop()">
                  <h6>支持中文/拼音/三字码/简拼</h6>
                  <div class="cityList-head df">
                    <span
                      v-for="(item, index) in cityListH"
                      :key="index"
                      :class="{'active': cityListHShow === index}"
                      @click.stop="cityListHShow = index"
                    >{{item}}</span>
                  </div>
                  <div class="cityList-c">
                    <div v-if="cityListHShow === 0 " class="hotCity">
                      <div class="HotCity">
                        <span
                          v-for="(item,index) in HotCity"
                          :key="index"
                          @click="getClickCity(item,'starCity')"
                        >{{item.name}}</span>
                      </div>
                    </div>
                    <div v-else class="AZCity">
                      <div v-for="(item,key,index) in cityList" :key="index">
                        <div
                          v-if="cityListH[cityListHShow].toLowerCase().indexOf(key.toLowerCase()) !== -1"
                          class="AZCityList df"
                        >
                          <div>
                            <p>{{key}}</p>
                          </div>
                          <div>
                            <span
                              v-for="(items,indexs) in item"
                              :key="indexs"
                              @click="getClickCity(items,'starCity')"
                            >{{items.name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="starCity df">
                <p>目的城市</p>
                <el-autocomplete
                  id="endCity"
                  v-model="endCity1"
                  clearable
                  :fetch-suggestions="(val,cd)=>querySearch(val,cd,'endCity1')"
                  placeholder="中文/拼音/三字码"
                  :trigger-on-focus="false"
                  @select="getendCity"
                  @focus.stop="CityFocus('endCity')"
                >
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }} ({{item.code}})</div>
                  </template>
                </el-autocomplete>
                <div class="cityList" v-if="EndList" @click.stop="stop()">
                  <h6>支持中文/拼音/三字码/简拼</h6>
                  <div class="cityList-head df">
                    <span
                      v-for="(item, index) in cityListH"
                      :key="index"
                      :class="{'active': cityListHShow === index}"
                      @click.stop="cityListHShow = index"
                    >{{item}}</span>
                  </div>
                  <div class="cityList-c">
                    <div v-if="cityListHShow ===0 " class="hotCity">
                      <div class="HotCity">
                        <span
                          v-for="(item,index) in HotCity"
                          :key="index"
                          @click="getClickCity(item,'endCity')"
                        >{{item.name}}</span>
                      </div>
                    </div>
                    <div v-else class="AZCity">
                      <div v-for="(item,key,index) in cityList" :key="index">
                        <div
                          v-if="cityListH[cityListHShow].toLowerCase().indexOf(key.toLowerCase()) !== -1"
                          class="AZCityList df"
                        >
                          <div>
                            <p>{{key}}</p>
                          </div>
                          <div>
                            <span
                              v-for="(items,indexs) in item"
                              :key="indexs"
                              @click="getClickCity(items,'endCity')"
                            >{{items.name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="transition">
                <span @click="transitionCity">换</span>
              </div>
            </div>
            <!-- <div class="city">
              <air-city class="starCity"></air-city>
              <air-city class="starCity"></air-city>
            </div>-->
            <div class="city" v-if="airType === 3">
              <div class="starCity df">
                <p>出发城市</p>
                <el-autocomplete
                  id="starTwoCity"
                  v-model="starTwoCity1"
                  clearable
                  :fetch-suggestions="(val,cd)=>querySearch(val,cd,'starTwoCity')"
                  placeholder="中文/拼音/三字码"
                  :trigger-on-focus="false"
                  @select="getstarTwoCity"
                  @focus.stop="CityFocus('starTwoCity')"
                >
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }} ({{item.code}})</div>
                  </template>
                </el-autocomplete>
                <div class="cityList" v-if="starTwoList" @click.stop="stop()">
                  <h6>支持中文/拼音/三字码/简拼</h6>
                  <div class="cityList-head df">
                    <span
                      v-for="(item, index) in cityListH"
                      :key="index"
                      :class="{'active': cityListHShow === index}"
                      @click.stop="cityListHShow = index"
                    >{{item}}</span>
                  </div>
                  <div class="cityList-c">
                    <div v-if="cityListHShow === 0 " class="hotCity">
                      <div class="HotCity">
                        <span
                          v-for="(item,index) in HotCity"
                          :key="index"
                          @click="getClickCity(item,'starTwoCity')"
                        >{{item.name}}</span>
                      </div>
                    </div>
                    <div v-else class="AZCity">
                      <div v-for="(item,key,index) in cityList" :key="index">
                        <div
                          v-if="cityListH[cityListHShow].toLowerCase().indexOf(key.toLowerCase()) !== -1"
                          class="AZCityList df"
                        >
                          <div>
                            <p>{{key}}</p>
                          </div>
                          <div>
                            <span
                              v-for="(items,indexs) in item"
                              :key="indexs"
                              @click="getClickCity(items,'starTwoCity')"
                            >{{items.name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="starCity df">
                <p>目的城市</p>
                <el-autocomplete
                  id="endTwoCity"
                  v-model="endTwoCity1"
                  clearable
                  :fetch-suggestions="(val,cd)=>querySearch(val,cd,'endTwoCity')"
                  placeholder="中文/拼音/三字码"
                  :trigger-on-focus="false"
                  @select="getendTwoCity"
                  @focus.stop="CityFocus('endTwoCity')"
                >
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }} ({{item.code}})</div>
                  </template>
                </el-autocomplete>
                <div class="cityList" v-if="EndTwoList" @click.stop="stop()">
                  <h6>支持中文/拼音/三字码/简拼</h6>
                  <div class="cityList-head df">
                    <span
                      v-for="(item, index) in cityListH"
                      :key="index"
                      :class="{'active': cityListHShow === index}"
                      @click.stop="cityListHShow = index"
                    >{{item}}</span>
                  </div>
                  <div class="cityList-c">
                    <div v-if="cityListHShow ===0 " class="hotCity">
                      <div class="HotCity">
                        <span
                          v-for="(item,index) in HotCity"
                          :key="index"
                          @click="getClickCity(item,'endTwoCity')"
                        >{{item.name}}</span>
                      </div>
                    </div>
                    <div v-else class="AZCity">
                      <div v-for="(item,key,index) in cityList" :key="index">
                        <div
                          v-if="cityListH[cityListHShow].toLowerCase().indexOf(key.toLowerCase()) !== -1"
                          class="AZCityList df"
                        >
                          <div>
                            <p>{{key}}</p>
                          </div>
                          <div>
                            <span
                              v-for="(items,indexs) in item"
                              :key="indexs"
                              @click="getClickCity(items,'endTwoCity')"
                            >{{items.name}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="transition">
                <span @click="transitionCity2">换</span>
              </div>
            </div>
            <div class="time-box">
              <div class="time df">
                <p class="demonstration" v-if="airType !==3">出发时间</p>
                <p class="demonstration" v-else>去程时间</p>
                <el-date-picker
                  v-model="time1"
                  align="right"
                  type="date"
                  placeholder="选择日期"
                  value-format="timestamp"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <div class="time df">
                <p class="demonstration df" v-if="airType !==3">返回时间</p>
                <p class="demonstration" v-else>回程时间</p>
                <el-date-picker
                  v-model="time2"
                  :disabled="time2Show"
                  :default-value="time1||''"
                  type="date"
                  value-format="timestamp"
                  :picker-options="pickerOptions2"
                  placeholder="选择日期"
                ></el-date-picker>
              </div>
            </div>
            <div class="air-ClassType2" v-if="airType !== 3">
              <div class="df">
                <p>舱位等级</p>
                <el-select v-model="ClassType">
                  <el-option
                    v-for="(item,index) in ClassTypeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="df">
                <p>航空公司</p>
                <!-- <el-select v-model="airlines">
                  <el-option
                    v-for="(item,index) in airlinesList"
                    :key="index"
                    :label="item.airCompanyName"
                    :value="item.airlineCode"
                  ></el-option>
                </el-select>-->
                <air-line-box :data="airlinesList" @selectItem="selectItem" :airLineCode="airlines"></air-line-box>
              </div>
            </div>
          </div>
        </div>
        <div class="air-ClassType df air-ClassType1 flex-center-end">
          <div class="el-checkbox-group">
            <el-radio v-model="psgType" :label="1" style="margin-right: 10px;">成人</el-radio>
            <el-radio v-model="psgType" :label="2" style="margin-right: 10px;">儿童</el-radio>
            <el-radio
              v-model="psgType"
              :label="3"
              style="margin-right: 10px;"
              v-show="airType==1"
            >成人+儿童</el-radio>
          </div>
          <div class="df" style="margin-right: 30px">
            <p style="font-size:14px;width:89px">起飞时段</p>
            <el-select v-model="params.takeOffInterval">
              <el-option
                v-for="(item,index) in takeOffTime"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="air-ClassType df air-ClassTypecw" v-if="airType === 3">
            <div class="df">
              <p>舱位等级</p>
              <el-select v-model="ClassType">
                <el-option
                  v-for="(item,index) in ClassTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="df" style="margin-right: 0">
              <p>航空公司</p>
              <el-select v-model="airlines">
                <el-option
                  v-for="(item,index) in airlinesList"
                  :key="index"
                  :label="item.airCompanyName"
                  :value="item.airlineCode"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <button
        @click="initSearch"
        style="border-radius:0"
        :disabled="loading"
        :style="{'background':loading?'#999':''}"
      >搜索</button>
    </div>
    <!-- 往返行程展示 -->
    <div v-if="typeShow !== 1 && itemOne.length !== 0" id="itemOne">
      <div class="flights-content">
        <div class="flights-contentT df" v-for="(item,index) in itemOne" :key="index">
          <div class="flights-name df">
            <img :src="item.airCompanyLogoImg || image_url_airline_blank_map" alt="">
            <div>
              <p>{{item.depDate}} {{getWeekDate(item.depDate)}}</p>
              <b>{{item.airCompanyName}}</b>
              <span>{{item.flightNo}}</span>
            </div>
          </div>
          <div class="go_text">去</div>
          <div class="flights-data df">
            <div class="flights-star">
              <h5>{{item.depCityName}}({{item.depCityCode}}){{item.depTime}}</h5>
              <span>{{item.depAirportName}} {{item.depTerminal}}</span>
            </div>
            <div class="arrows">
              <span
                v-if="item.stopNum"
                @mousemove="arrowsShow = index + 1"
                @mouseout="arrowsShow = null"
                style="color:#237dc9"
              >经停</span>
              <span v-else>直达</span>
              {{item.duration.replace(/h/g,"小时").replace(/m/g,"分")}}
              <air-stop
                :flightNo="item.flightNo"
                :stopNum="item.stopNum>0?Math.random()*8:0"
                v-show="arrowsShow===index + 1"
                class="airStopBox"
              />
            </div>
            <div class="flights-end">
              <h5>{{item.arrCityName}}({{item.arrCityCode}}){{item.arrTime}}</h5>
              <span>{{item.arrAirportName}} {{item.arrTerminal}}</span>
            </div>
          </div>
          <div class="flights-close">
            <b>结算价:</b>
            <p>
              <sup>￥</sup>
              <span>{{!$refs.inlandFlight.checkedTax?item.policys.priceData[0].rebatePrice:item.policys.priceData[0].settlementPriceTaxes}}</span>
              <span>（{{!$refs.inlandFlight.checkedTax?'不含税':'含税'}}）</span>
            </p>
            <i></i>
          </div>
          <div class="flights-more" @click="initSearch('amend')">
            <b>修改航班</b>
          </div>
        </div>
      </div>
    </div>
    <!-- 日历 -->
    <calendar-box
      :saveWeek="saveWeek"
      @clickDate="clickDate"
      :initStatu="initStatu"
      :typePage="true"
    ></calendar-box>
    <!-- 航班列表展示部分 -->
    <inland-flight-list
      ref="inlandFlight"
      :loading="loading"
      :flightTimeSort="flightTimeSort"
      :flightSartSort="flightSartSort"
      :flightsList="flightsList"
      :flightEndSort="flightEndSort"
      :journeyType="journeyType"
      :backRule="backRule"
      :psgType="psgType"
      :creditState="creditState"
      :reserveType="reserveType"
      :luggage="luggage"
      :ruleText="ruleText"
    ></inland-flight-list>
  </div>
</template>

<script>
// 城市列表查询
import AirStop from "./components/airStop";

const citys = require(`../../../lib/data-service/flight/flight_domestic_citys`);
// 国内航空公司查询
const airlines = require(`../../../lib/data-service/flight/flight_domestic_airlines`);
// 国内航班列表查询
const flights = require(`../../../lib/data-service/flight/flight_domestic_flights`);
import rule from "@/lib/data-service/flight/newFligthApi/buyer_dom_white_rule";
import luggage from "@/lib/data-service/flight/buyer_dom_white_luggage";
const _ = require(`underscore`);
import CalendarBox from "./components/calendar";
import airLineBox from "./components/airLine";
import InlandFlightList from "./components/inlandFlightList";
import moment from "moment";
import AirCity from "./components/airCityAddress";
export default {
  data() {
    return {
      pickerOptions: this.setEndTime1(),
      arrowsShow: null,
      flightSartSort: true,
      flightEndSort: true,
      airType: 1, // 航程类型
      clauseShow: null,
      airTypeShow: true,
      loadingShow: 0,
      pickerOptions2: this.setEndTime(), //  返回时间
      time1: null, //  出发时间
      time2: null, //  返回时间
      time2Show: true, // 返回时间是否可用
      timeRoll: 1569772800000, //滚动条时间
      starCity: "", // 出发城市
      starCity1: "", // 展示出发城市
      starTwoCity: "", // 第二出发城市
      starTwoCity1: "", // 第二展示出发城市
      endCity: "", // 目的城市
      endCity1: "", // 展示目的城市
      endTwoCity: "", // 第二目的城市
      endTwoCity1: "", // 第二展示目的城市
      cityList: [], // 城市字母列表
      restaurants: [], // 所有城市机场列表
      cityListH: ["热门", "ABCD", "EFGH", "JKLM", "NOPQRS", "TUVWX", "YZ"], // 热门列表
      HotCity: [], //  热门城市列表
      cityListHShow: 0, //  热门列表index
      starList: false, //  出发城市列表显示
      EndList: false, //  目的城市列表显示
      starTwoList: false, //  出发城市列表显示
      EndTwoList: false, //  目的城市列表显示
      ClassType: 0, //  舱位选择
      typeShow: 1,
      creditState: false,
      ClassTypeList: [
        //  舱位列表
        {
          value: 0,
          label: "不限"
        },
        {
          value: 1,
          label: "头等舱"
        },
        {
          value: 2,
          label: "公务舱"
        },
        {
          value: 3,
          label: "经济舱"
        }
      ],
      psgType: 1, //  乘机人类型
      airlines: "", //  航司
      airlinesList: [
        //  航司列表
        {
          airlineCode: "",
          airCompanyName: "不限"
        }
      ],
      timeIndex: 0, // 已选的class
      flightsList: [], // 航班列表
      loading: false, //  加载中
      flightsIndex: 0, //  当前展示的列表
      flightsShow: false, // 是否展示
      reserveType: "预订", // 按钮状态
      params: {
        takeOffInterval: ""
      }, // 搜索传参
      itemOne: [], //  第一行程
      image_url_airline_blank_map: `https://lyn.oss-cn-shenzhen.aliyuncs.com/temp/airline-blank-map.jpg`,
      weekList: [],
      weekBtnStatu: false,
      saveWeek: "",
      ruleText: [],
      luggage: "",
      ruleObj: {},
      segmentsList: [],
      initStatu: 0,
      takeOffTime: [
        { value: "", label: "全部" },
        { value: "00:00-05:59", label: "00:00-05:59" },
        { value: "06:00-11:59", label: "06:00-11:59" },
        { value: "12:00-17:59", label: "12:00-17:59" },
        { value: "18:00-23:59", label: "18:00-23:59" }
      ]
    };
  },
  components: {
    CalendarBox,
    airLineBox,
    InlandFlightList,
    AirStop,
    AirCity
  },
  methods: {
    flightTimeSort(type) {
      if (this.flightsList.length == 0) return;
      if (type === "start") {
        this.flightSartSort = !this.flightSartSort;
        this.flightEndSort = !this.flightEndSort;
        // depTime
        this.timeSort(this.flightsList, "depTime", this.flightSartSort);
      } else {
        this.flightEndSort = !this.flightEndSort;
        this.flightSartSort = !this.flightSartSort;
        // arrTime
        this.timeSort(this.flightsList, "arrTime", this.flightEndSort);
      }
    },
    timeSort(list, name, arrangeType) {
      if (arrangeType) {
        list.sort((a, b) => {
          let one = moment(this.time1).format("YYYY-MM-DD") + " " + a[name];
          let two = moment(this.time1).format("YYYY-MM-DD") + " " + b[name];
          return moment(one).valueOf() - moment(two).valueOf();
        });
      } else {
        list.sort((a, b) => {
          let one = moment(this.time1).format("YYYY-MM-DD") + " " + a[name];
          let two = moment(this.time1).format("YYYY-MM-DD") + " " + b[name];
          return moment(two).valueOf() - moment(one).valueOf();
        });
      }
    },
    clickDate(val) {
      if (this.itemOne.length !== 0) {
        this.params.beginDate = val;
        this.time2 = new Date(val);
      } else {
        this.params.beginDate = val;
        this.time1 = new Date(val);
      }
      this.saveWeek = val;
      this.initStatu = 0;
      this.search();
    },
    initSearch(val) {
      val == "amend"
        ? ((this.itemOne.length = 0), (this.segmentsList.length = 0))
        : ((this.itemOne.length = 0), (this.segmentsList.length = 0));
      if (this.itemOne.length > 0) {
        this.saveWeek = this.$moment(this.time2).format("YYYY-MM-DD");
      } else {
        this.saveWeek = this.$moment(this.time1).format("YYYY-MM-DD");
      }
      this.initStatu++;
      this.search();
    },
    // 日期选择
    setEndTime() {
      let _this = this;
      return {
        disabledDate: time => {
          if (_this.time1) {
            return time.getTime() < _this.time1;
          } else {
            return time.getTime() < Date.now() - 1000 * 3600 * 24;
          }
        }
      };
    },
    setEndTime1() {
      let _this = this;
      return {
        disabledDate: time => {
          if (_this.time2 && this.airType === 2) {
            return (
              time.getTime() > _this.time2 ||
              time.getTime() < Date.now() - 1000 * 3600 * 24
            );
          } else {
            return time.getTime() < Date.now() - 1000 * 3600 * 24;
          }
        }
      };
    },
    querySearch(queryString, cb, name) {
      var res = this.restaurants;
      var results = queryString
        ? res.filter(this.createFilter(queryString))
        : "";
      // 调用 callback 返回建议列表的数据
      results.length === 0 ? (this[name] = "") : "";
      cb(results);
    },
    // createFilter(queryString) {
    //   return res => {
    //     if (res.spell.toUpperCase() === queryString.toUpperCase()) {
    //       return res;
    //     } else if (res.name === queryString) {
    //       return res;
    //     } else if (res.code.indexOf(queryString.toUpperCase()) !== -1) {
    //       return res;
    //     } else if (res.cityCode.indexOf(queryString.toUpperCase()) !== -1) {
    //       return res;
    //     }
    //   };
    // },
    createFilter(queryString) {
      let pattern2 = new RegExp("[A-Za-z]+");
      if (pattern2.test(queryString)) {
        return restaurant => {
          if (restaurant.spell && restaurant.code) {
            if (restaurant.code.indexOf(queryString.toUpperCase()) != -1) {
              return restaurant;
            } else if (
              restaurant.spell
                .toUpperCase()
                .indexOf(queryString.toUpperCase()) != -1
            ) {
              return restaurant;
            }
          } else {
            return "";
          }
        };
      } else {
        return restaurant => {
          if (restaurant.cityName.indexOf(queryString) !== -1) {
            return restaurant;
          } else {
            return "";
          }
        };
      }
    },
    selectItem(val) {
      this.airlines = val;
    },
    // 获取城市接口
    loadAllCity() {
      citys().then(res => {
        this.restaurants = [...res.citys];
        let cityList = [];
        for (let i = 0; i < res.citys.length; i++) {
          if (res.citys[i].airports === false) {
            cityList.push(res.citys[i]);
          }
          if (
            res.citys[i].isHot === "Y" &&
            this.HotCity.length < 23 &&
            res.citys[i].airports === false
          ) {
            this.HotCity.push(res.citys[i]);
          }
        }
        this.cityList = _.chain(cityList)
          .groupBy(function(m) {
            return m.initial;
          })
          .value();
        this.restaurants = this.setCityName(this.restaurants, cityList);
        // console.log("城市", this.restaurants);
      });
    },
    //  _getWeek(val){
    //         let arr = []
    //         val?val:''
    //         for(let i = 0;i<7;i++){
    //             let dateTime = this.$moment(val).subtract(-i, 'days').format('YYYY-MM-DD')
    //             let week = this.$moment(val).subtract(-i, 'days')._d
    //             week = week.getDay()
    //            week =  week===0?'星期日':week===1?'星期一':week===2?'星期二':week===3?'星期三':week===4?'星期四':week===5?'星期五':'星期六'
    //             let obj = {
    //                 week:week,
    //                 date:dateTime,
    //                 statu:false,
    //             }
    //             arr.push(obj)
    //         }
    //         this.weekList = arr
    //         if(this.saveWeek){
    //           arr.map((item,index)=>{
    //               item.date===this.saveWeek?
    //               item.statu = true:''
    //           })
    //         }
    //     },
    // 城市转换
    transitionCity() {
      let city = this.starCity;
      this.starCity = this.endCity;
      this.endCity = city;
      let city1 = this.starCity1;
      this.starCity1 = this.endCity1;
      this.endCity1 = city1;
    },
    transitionCity2() {
      let city = this.starTwoCity;
      this.starTwoCity = this.endTwoCity;
      this.endTwoCity = city;
      let city1 = this.starTwoCity1;
      this.starTwoCity1 = this.endTwoCity1;
      this.endTwoCity1 = city1;
    },
    ransitionCity2() {
      let city = this.starTwoCity;
      this.starTwoCity = this.endTwoCity;
      this.endTwoCity = city;
      let city1 = this.starTwoCity1;
      this.starTwoCity1 = this.endTwoCity1;
      this.endTwoCity1 = city1;
    },
    // 获取出发城市
    getstarCity(item) {
      this.starCity = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.starCity1 = item.name + "(" + item.code + ")";
      console.log(item, this.starCity);
    },
    getstarTwoCity(item) {
      this.starTwoCity = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.starTwoCity1 = item.name + "(" + item.code + ")";
      console.log(item);
    },

    getWeekDate(timeDay) {
      var now = new Date(timeDay);
      var day = now.getDay();
      var weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );
      var week = weeks[day];
      return week;
    },
    setCityName(restaurants, cityList) {
      let airList = restaurants.filter(item => {
        item.cityName = item.name;
        return item.airports;
      });
      airList.map(item => {
        cityList.map(sitem => {
          if (item.spell === sitem.spell) {
            item.cityName = sitem.name;
          }
        });
      });
      return restaurants;
    },
    // 获取目的城市
    getendCity(item) {
      this.endCity = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.endCity1 = item.name + "(" + item.code + ")";
      console.log(item);
    },
    getendTwoCity(item) {
      this.endTwoCity = item.airports
        ? item.code
        : item.cityCode
          ? item.cityCode
          : item.code;
      this.endTwoCity1 = item.name + "(" + item.code + ")";
      console.log(item);
    },
    // 获取点击的城市
    getClickCity(item, data) {
      // console.log(item)
      if (data === "starCity") {
        this.starCity = item.airports
          ? item.code
          : item.cityCode
            ? item.cityCode
            : item.code;
        this.starCity1 = item.name + "(" + item.code + ")";
        this.starList = false;
      }
      if (data === "endCity") {
        this.endCity = item.airports
          ? item.code
          : item.cityCode
            ? item.cityCode
            : item.code;
        this.endCity1 = item.name + "(" + item.code + ")";
        this.EndList = false;
      }
      if (data === "starTwoCity") {
        this.starTwoCity = item.airports
          ? item.code
          : item.cityCode
            ? item.cityCode
            : item.code;
        this.starTwoCity1 = item.name + "(" + item.code + ")";
        this.starTwoList = false;
      }
      if (data === "endTwoCity") {
        this.endTwoCity = item.airports
          ? item.code
          : item.cityCode
            ? item.cityCode
            : item.code;
        this.endTwoCity1 = item.name + "(" + item.code + ")";
        this.EndTwoList = false;
      }
    },
    // 获取焦点显示热门的城市
    CityFocus(data) {
      if (this.starCity1 === "" && data === "starCity") {
        this.starList = true;
        this.EndList = false;
        this.starTwoList = false;
        this.EndTwoList = false;
      }
      if (this.endCity1 === "" && data === "endCity") {
        this.starList = false;
        this.EndList = true;
        this.starTwoList = false;
        this.EndTwoList = false;
      }
      if (this.starTwoCity1 === "" && data === "starTwoCity") {
        this.starList = false;
        this.EndList = false;
        this.starTwoList = true;
        this.EndTwoList = false;
      }
      if (this.endTwoCity1 === "" && data === "endTwoCity") {
        this.starList = false;
        this.EndList = false;
        this.starTwoList = false;
        this.EndTwoList = true;
      }
    },
    noneShow() {
      let Starfocus = document.getElementById("starCity");
      let endCity = document.getElementById("endCity");
      let StarTwofocus = document.getElementById("starTwoCity");
      let endTwoCity = document.getElementById("endTwoCity");
      if (StarTwofocus !== document.activeElement) {
        this.starTwoList = false;
      }
      if (endTwoCity !== document.activeElement) {
        this.EndTwoList = false;
      }
      if (Starfocus !== document.activeElement) {
        this.starList = false;
      }
      if (endCity !== document.activeElement) {
        this.EndList = false;
      }
    },
    // 阻止事件冒泡
    stop() {},
    // 获取航司列表
    getAirlines() {
      airlines({ pageSize: 100000 }).then(data => {
        // console.log(data)
        let airlinesList = [...this.airlinesList, ...data.pageResult.pageData];
        airlinesList.map(item => {
          item.value = item.airCompanyName + "(" + item.airlineCode + ")";
        });
        this.airlinesList = airlinesList;
      });
    },
    // 搜索航班列表
    search() {
      let params = {
        // 航程类型
        flightType: this.airType === 2 ? 2 : 1,
        needPnr: 0,
        // 出发城市三字码。
        depCityPortCode: this.starCity,
        // 到达城市三字码。
        arrCityPortCode: this.endCity,
        // 出发日期
        depDate: this.$moment(this.saveWeek).format("YYYY-MM-DD"),
        // 仓位等级 0=不限 1=头等舱 2=公务舱 3=经济舱。
        cabinRank: this.ClassType,
        // 航空公司二字码
        airLineCode: this.airlines,
        // psgType
        psgType: this.psgType,
        //  是否直飞
        directFlight: 0,
        // 折扣
        discount: 0,
        takeOffInterval: this.params.takeOffInterval
      };
      // this.timeRoll = this.time1
      this.params = Object.assign({}, params);

      this.typeShow = this.airType;
      // console.log(this.params)
      if (!this.time1)
        return this.$message({ message: "请选择出发时间", type: "warning" });
      if (this.airType === 1) {
        this.reserveType = "预订";
      } else if (this.airType === 2 && this.itemOne.length == 0) {
        this.reserveType = "选为去程";
      } else {
        this.reserveType = "选为回程";
      }
      if (this.airType === 2 && this.time2 === null) {
        return this.$message({
          message: "请选择回程时间",
          type: "warning"
        });
      }

      // this.saveWeek = this.params.depDate
      this.getflights(this.params);
    },

    // 获取航班列表
    getflights(params) {
      // console.log(params)
      this.loading = true;
      this.flightsList = [];
      flights(params)
        .then(data => {
          if (data.flights) {
            this.loading = false;
            let flightsList = data.flights
            flightsList.forEach((value, index) => {
              let rebatePrice = 0
              let settlementPriceTaxes = 0
              value.policys.forEach((value1, index1) => {
                if (index1 === 0) {
                  rebatePrice = value1.priceData[0].rebatePrice
                  settlementPriceTaxes = value1.priceData[0].settlementPriceTaxes
                } else {
                  if (rebatePrice > value1.priceData[0].rebatePrice) {
                    rebatePrice = value1.priceData[0].rebatePrice
                  }
                  if (settlementPriceTaxes > value1.priceData[0].settlementPriceTaxes) {
                    settlementPriceTaxes = value1.priceData[0].settlementPriceTaxes
                  }
                }
              })
              value.rebatePrice = rebatePrice
              value.settlementPriceTaxes = settlementPriceTaxes
            })
            this.flightsList = flightsList;
            this.creditState = data.creditState;
            this.airTypeShow = true;
          } else {
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 输出周几
    // Getweek (index) {
    //   let str = [
    //     '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'
    //   ]
    //   let week = Number(this.$moment(this.timeRoll + (index * 1000 * 3600 * 24)).format('E')) - 1
    //   return str[week]
    // },
    // // 输出日期
    // getTime(index) {
    //   let day = 1000 * 3600 * 24
    //   let daynub = (this.timeRoll- - new Date(new Date().setHours(0,0,0,0))) / day
    //   if (daynub >= 3) {
    //     index = index - 2
    //     this.timeIndex = 2
    //     return this.$moment(this.timeRoll + (index * 1000 * 3600 * 24)).format('YYYY-MM-DD')
    //   } else {
    //     index = index - daynub
    //     this.timeIndex = daynub
    //     return this.$moment(this.timeRoll + (index * 1000 * 3600 * 24)).format('YYYY-MM-DD')
    //   }
    // },
    // 点击时间滚动条内容获取时间
    setTime(val) {
      this.weekList.map(item => {
        item.statu = false;
      });
      val.statu = true;
      this.saveWeek = val.date;
      this.weekBtnStatu = false;
      // this.timeRoll = this.timeRoll + ((index - this.timeIndex) * 1000 * 3600 * 24)
      if (this.itemOne.length !== 0) {
        console.log("回程1", this.$moment(this.time2).format("YYYY-MM-DD"));
        // this.time2 = this.timeRoll
        // this.params.sCityPortCode = this.endCity
        // this.params.eCityPortCode = this.starCity
        this.params.beginDate = this.$moment(this.time2).format("YYYY-MM-DD");
        this.time2 = new Date(val.date).valueOf();
        // this.params.beginDate = val.date
        this.getflights(this.params);
      } else {
        console.log("去程2");
        // this.time1 = this.timeRoll
        // this.params.beginDate = this.$moment(this.time1).format('YYYY-MM-DD')
        this.params.beginDate = val.date;
        this.getflights(this.params);
        this.time1 = new Date(val.date).valueOf();
      }
    },

    //退改规则
    backRule(val, policys) {
      // if(Object.keys(this.ruleObj).length>0){
      //    if(this.ruleObj.depTime==val.depTime)return
      // }
      this.ruleText = [];
      this.ruleObj = val;
      let data = {
        arrCityPortCode: val.arrAirportCode,
        cabinCode:
          this.psgType == 2
            ? policys.cabin.chdCabinCode
            : policys.cabin.cabinCode,
        depCityPortCode: val.depAirportCode,
        depDate: val.depDate,
        flightNo: val.flightNo,
        flightType: this.airType,
        psgType: this.psgType,
        supplierType: policys.supplierType || 1,
        policyId: policys.policyId,
        extData: policys.extData,
      };
      this.getLuggage(data);
      rule(data).then(res => {
        let refRule = res.refRule.rules;
        let chaRule = res.chaRule.rules;
        if (refRule && chaRule) {
          refRule.map(item => (item.type = "refRule"));
          chaRule.map(item => (item.type = "chaRule"));
          this.ruleText = [refRule, chaRule];
        }
        // this.ruleText = res.chaRule.content;
      });
    },
    getLuggage(data) {
      luggage(data).then(res => {
        this.luggage = res.luggage;
      });
    },

    // 行程选择
    journeyType(data, policys) {
      let item = { ...data };
      let formData = {
        cabinRank: this.ClassType,
        directFlight: 0,
        flightType: this.airType,
        psgType: this.psgType,
        segments: []
      };
      let segments = {
        arrCityPortCode: data.arrAirportCode,
        cabinCode: policys.cabin.cabinCode,
        depCityPortCode: data.depAirportCode,
        depDate: data.depDate,
        flightNo: data.flightNo,
        policyId: policys.policyId,
        segmentType: this.segmentsList.length > 0 ? 2 : 1,
        supplierType: policys.supplierType || 1
      };
      /**单程 */
      if (this.typeShow === 1) {
        formData.segments.push(segments);
        this.$router.push({
          name: "airOrders",
          query: {
            airdata: JSON.stringify(formData)
            // flight: JSON.stringify(data)
          }
        });
        return;
      }

      if (this.typeShow === 2) {
        this.segmentsList.push(segments);
        formData.segments = this.segmentsList;
        console.log(formData);
        if (this.segmentsList.length == 2) {
          return this.$router.push({
            name: "airOrders",
            query: {
              airdata: JSON.stringify(formData)
              // flight: JSON.stringify(data)
            }
          });
        }
      }
      if (this.typeShow === 2) {
        this.reserveType = "选为回程";
        // console.log(this.params)
        item.policys = policys;
        this.itemOne.push(item);
        // console.log(this.itemOne)
        this.$forceUpdate();
        this.params.depCityPortCode = this.endCity;
        this.params.arrCityPortCode = this.starCity;
        this.saveWeek = this.params.depDate = this.$moment(this.time2).format(
          "YYYY-MM-DD"
        );
        // this.timeRoll = this.time2
        this.loading = true;
        this.getflights(this.params);
        this.initStatu++;
        // this._getWeek(this.params.depDate)
      }
      // if (this.airType === 3 && this.airTypeShow) {
      //   this.reserveType = '选为回程'
      //   // console.log(this.params)
      //   item.policys = item.policys[index]
      //   this.itemOne.push(item)
      //   // console.log(this.itemOne)
      //   this.$forceUpdate();
      //   this.params.sCityPortCode = this.starTwoCity
      //   this.params.eCityPortCode = this.endTwoCity
      //   this.params.beginDate = this.$moment(this.time2).format('YYYY-MM-DD')
      //   this.timeRoll = this.time2
      //   this.loading = true
      //   this.getflights(this.params)
      // }
    }
  },
  watch: {
    airType() {
      if (this.airType === 1) {
        this.time2Show = true;
      } else {
        this.time2Show = false;
      }
      if (this.airType === 2 && this.time1 > this.time2) {
        this.time2 = null;
      }
      this.airTypeShow = false;
      this.itemOne = [];
    },
    // 出发城市1
    starCity1(val) {
      let Starfocus = document.getElementById("starCity");
      if (this.starCity1 !== "") {
        this.starList = false;
      }
      if (Starfocus === document.activeElement && this.starCity1 === "") {
        this.starList = true;
        this.starCity = "";
        console.log(this.starCity, this.starCity1);
      }
    },
    // 目的城市1
    endCity1() {
      let endCity = document.getElementById("endCity");
      if (this.endCity1 !== "") {
        this.EndList = false;
      }
      if (endCity === document.activeElement && this.endCity1 === "") {
        this.EndList = true;
      }
    },
    // 出发城市2
    starTwoCity1() {
      let Starfocus = document.getElementById("starTwoCity");
      if (this.starTwoCity1 !== "") {
        this.starTwoList = false;
      }
      if (Starfocus === document.activeElement && this.starTwoCity1 === "") {
        this.starTwoList = true;
      }
    },
    // 目的城市2
    endTwoCity1() {
      let endCity = document.getElementById("endTwoCity");
      if (this.endTwoCity1 !== "") {
        this.EndTwoList = false;
      }
      if (endCity === document.activeElement && this.endTwoCity1 === "") {
        this.EndTwoList = true;
      }
    }
  },
  mounted() {
    this.loadAllCity();
  },
  async created() {
    this.getAirlines();
    if (this.$route.query.airdata) {
      let params = JSON.parse(this.$route.query.airdata);
      this.airType = params.airType;
      (this.time1 = params.time1), //  出发时间
        (this.time2 = params.time2), //  返回时间
        (this.time2Show = params.time2Show), // 返回时间是否可用
        // this.timeRoll =  params.timeRoll, //滚动条时间
        (this.starCity = params.starCity), // 出发城市
        (this.starCity1 = params.starCity1), // 展示出发城市
        (this.starTwoCity = params.starTwoCity), // 第二出发城市
        (this.starTwoCity1 = params.starTwoCity1), // 第二展示出发城市
        (this.endCity = params.endCity), // 目的城市
        (this.endCity1 = params.endCity1), // 展示目的城市
        (this.endTwoCity = params.endTwoCity), // 第二目的城市
        (this.endTwoCity1 = params.endTwoCity1), // 第二展示目的城市
        (this.psgType = params.psgType);
      (this.ClassType = params.ClassType), //舱位等级
        (this.airlines = params.airlines);
      this.saveWeek = this.$moment(params.time1).format("YYYY-MM-DD");
      this.search();
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./components/css/flight.less");
.flights-contentT {
  padding-left: 0 !important;
  margin-top: 10px;
  background-color: white !important;
}
.go_text {
  background: #a7a7a7 !important;
}
.flights-close {
  display: flex;
  align-items: center;
  font-family: Microsoft YaHei;
  span {
    color: #707070;
  }
  span:nth-child(2) {
    color: #f60;
    font-size: 28px;
  }
  p {
    sup {
      display: inline-block;
      transform: translateY(-7px);
      color: #707070;
    }
  }
  b {
    font-size: 14px;
    font-weight: bolder;
    color: #666;
    padding-right: 5px;
  }
}
.flights-name {
  img {
    width: 32px;
    height: 27px;
    margin-right: 8px;
  }
  div {
    color: #333;
    font-size: 12px;
    p {
      font-size: 14px;
      color: #ff6600;
      font-weight: bolder;
      padding-bottom: 3px;
    }
    b {
      font-weight: bolder;
    }
    span {
      color: #707070;
      padding-left: 5px;
    }
  }
}
/deep/.airStopBox {
  // top: 30px;
  .arrows-stop-box {
    top: 30px;
  }
}
.flights-more {
  font-size: 14px;
}
</style>
